var render, staticRenderFns
import script from "./right.vue?vue&type=script&lang=js&"
export * from "./right.vue?vue&type=script&lang=js&"
import style0 from "./right.vue?vue&type=style&index=0&id=0422f188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0422f188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\el-dynamic-form-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0422f188')) {
      api.createRecord('0422f188', component.options)
    } else {
      api.reload('0422f188', component.options)
    }
    
  }
}
component.options.__file = "src/render/right.vue"
export default component.exports